// eslint-disable-next-line
import { useNavigate } from "react-router-dom";

import { Stack, Typography } from "@mui/material";

export default function Main() {
  //   const navigate = useNavigate();

  const sx = {
    wrapper: {
      width: 1300,
      alignItems: "center",
      justifyContent: "space-between",
      py: 4,
    },
    btn: { cursor: "pointer" },
  };

  return (
    <Stack sx={sx.wrapper} direction="row" spacing={4}>
      <Stack>
        <Typography sx={sx.btn}>Privacy Policy - Terms of Service</Typography>
        <Typography sx={sx.btn}>Copyright @ Cybersecurity 2025</Typography>
      </Stack>

      <Stack direction="row" spacing={1}>
        <Typography sx={sx.btn}></Typography>
        <Typography sx={sx.btn}></Typography>
      </Stack>
    </Stack>
  );
}
